//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    noticeData: {
      type: Object,
      default: () => ({})
    },
    showAll: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    readNotification(id) {
      this.$store.dispatch('notify/readNotification', id)
    }
  }
}
